import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { EyeOff, CheckCircle2 } from "lucide-react";
import { getPrivacy } from "@/lib/api";

const LABELS = { phone: "Phone (Call/WhatsApp)", address: "Address", map: "Map location", pincode: "PIN code", photo: "Profile photo" };

// Owner-only note in Customer View; reads the owner's own saved settings.
export default function HiddenItemsNote({ returnTo }) {
  const navigate = useNavigate();
  const [hidden, setHidden] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    getPrivacy().then((s) => setHidden(Object.keys(LABELS).filter((k) => s.privacy[k] === false))).catch(() => setErr(true));
  }, []);
  const change = () => navigate(`/vendor?toolbag=1&panel=privacy-settings&return=${encodeURIComponent(returnTo)}`);
  if (err) return null;
  return (
    <div className="bg-emerald-50 border-b border-emerald-100 text-emerald-900 text-xs sm:text-sm px-4 py-2 flex items-center gap-3" data-testid="hidden-items-note">
      <div className="flex-1 min-w-0 flex flex-wrap items-center gap-1.5">
        {hidden === null ? <span className="text-slate-500">Loading...</span> : hidden.length === 0 ? (
          <span className="inline-flex items-center gap-1.5" data-testid="hidden-items-none"><CheckCircle2 className="w-4 h-4 text-emerald-700" /> All selected public details are visible.</span>
        ) : (
          <>
            <span className="inline-flex items-center gap-1 font-semibold"><EyeOff className="w-4 h-4 text-emerald-700" /> Customers se chhupa:</span>
            {hidden.map((k) => <span key={k} className="rounded-full bg-white border border-emerald-200 px-2 py-0.5 font-semibold" data-testid={`hidden-item-${k}`}>{LABELS[k]}</span>)}
          </>
        )}
      </div>
      <button onClick={change} className="vb-nav flex-shrink-0 rounded-full border border-emerald-300 bg-white px-3 py-1" data-testid="hidden-items-change-btn">Badlein</button>
    </div>
  );
}
